import { Flex } from 'antd';
import styles from './update-channel.module.scss';
import { ChannelUpdatePage } from '@modules/channels/ui/channel-update-page/channel-update-page';

export const UpdateChannel = () => (
  <Flex className={styles.root}>
    <ChannelUpdatePage />
  </Flex>
);
